const namespace = 'chatRoom';

// 初始化聊天室连接
export const INIT_CHAT_ROOM = 'initChatRoom';
export const DISPATCH_INIT_CHAT_ROOM = `${namespace}/${INIT_CHAT_ROOM}`;

